import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

import { AuthService } from '@main-client/src/app/auth/auth.service';

@Injectable()
export class PreregistrationLegacyGuardService implements CanActivate {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot) {
    const token = route.queryParamMap.get('token');
    if (!this.authService.$isLoggedIn() && token) {
      return this.router.createUrlTree(['/signup'], {
        queryParams: { token },
      });
    }
    return true;
  }
}
